import React from 'react'

import Text from '../../components/form/form-text'
import Anchor from '../../components/form/form-anchor'
import DateStr from '../../components/form/form-date-time-picker'

import {openPagesPickerPage as openPages} from '../../containers/picker/picker-actions'


export function openPagesPickerPage(panelId, select) {
    openPages(panelId, select)
}

export function printPage(page) {
    return <div className="module-link-page" >
        <Text className="table-list-column name" value={page.title} disabled={true} />
        <DateStr className="table-list-column date" dateFormat="DD MMMM YYYY HH:mm" value={page.publishAt} />
        <DateStr className="table-list-column date" dateFormat="DD MMMM YYYY HH:mm" value={page.createdAt} />
        {/*<Text className="table-list-column" value={this.status()} />*/}
        <Anchor className="table-list-column" href={page.url} />
    </div>
}
